import { Component, OnInit, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MasterConstants } from '../../../common/constants/master-constants';

import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { RowSpanComputer, Span } from '../../../services/common/row-span-computer';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './../../../common/components/confirm-dialog/confirm-dialog.component';

import { NavigationStart, Router } from '@angular/router';
import { CppSraCostSheetService } from '../../../services/cpp-sra-cost-sheet/cpp-sra-cost-sheet.service';
import { ColumnDescription } from '../../../models/user-report-filter.model';
import { CommonService } from './../../../services/common/common.service';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';

@Component({
  selector: 'app-cpp-sra-cost-sheet-price-simulation',
  templateUrl: './cpp-sra-cost-sheet-price-simulation.component.html',
  styleUrls: ['./cpp-sra-cost-sheet-price-simulation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CppSraCostSheetPriceSimulationComponent implements OnInit, OnDestroy {
  @ViewChild('costSheetSimulationPaginator', { read: MatPaginator }) costSheetSimulationPaginator: MatPaginator;

  subscription = new Subscription();
  masterConstants = MasterConstants;
  private subscriptionArray = new Array<Subscription>();
  costSheetDataSimulationList: any = [];
  filterList: any = [];
  costSheetDataSimulationSource = new MatTableDataSource();
  rowSpans: Array<Span[]>;
  private rowSpanComputer = new RowSpanComputer();
  checked = false;
  NumericPattern: any = /^\d*(\.\d{0,15})?$/;
  hasChangeAdded = false;
  subscriptionForSraReload;
  isSimulationDisable: Boolean = true;
  isRunSimulationDisable: Boolean = true;
  isResetAllDisable: Boolean = true;
  isAcceptRateDisable: Boolean = true;
  simulationExportFilters: any;
  columnSelection: any = {
    manufacturerSurcharge: true,
    distributionCost: true,
    retailStockingRebate: true,
    retailUnpublishedRebates: true,
    retailLocalRebate: true
  };
  private originalDisplayedColumns: Array<ColumnDescription> = [];

  columnNames: string[] = [];

  columnName = ['customerNumber', 'customerName'];
  group1Cols = ['wholesaleRebatePcguidance', 'srarebatePcguidance', 'distributorList', 'manufacturerSurcharge', 'distributionCost', 'lowNetwoPrepay']
  group2Cols = ['nationalPrice', 'competitiveAllowancePc', 'specialPricePc', 'manufacturerSurcharge', 'lowNetwoPrepay']
  group3Cols = ['contractPrepayPc', 'lowNetwoPrepay', 'lowNetwPrepay']
  columnInvolvement = {
    wholesaleRebatePcguidance: this.group1Cols,
    distributorList: this.group1Cols,
    srarebatePcguidance: this.group1Cols,
    distributionCost: this.group1Cols,
    nationalPrice: this.group2Cols,
    competitiveAllowancePc: this.group2Cols,
    specialPricePc: this.group2Cols,
    contractPrepayPc: this.group3Cols,
    lowNetwPrepay: this.group3Cols
  };
  coloumnToAddHeaderCss = {
    'wholesaleRebatePcguidance': false,
    'srarebatePcguidance': false,
    'distributorList': false,
    'manufacturerSurcharge': false,
    'distributionCost': false,
    'lowNetwoPrepay': false,
    'nationalPrice': false,
    'competitiveAllowancePc': false,
    'manufacturerSurchargePc': false,
    'specialPricePc': false,
    'lowNetwPrepay': false,
    'contractPrepayPc': false
  };

  tilesList: Array<any> = [
    { id: 'retailBaseRebates', text: 'NATIONAL MFG PUBLISHED REBATE', selected: false, rateValue: null, prevRateValue: null },
    { id: 'retailStockingRebate', text: 'RETAIL STOCKING REBATE %', selected: false, rateValue: null, prevRateValue: null },
    { id: 'retailUnpublishedRebates', text: 'RETAIL UNPUBLISHED REBATES %', selected: false, rateValue: null, prevRateValue: null },
    { id: 'retailLocalRebate', text: 'RETAIL LOCAL REBATE', selected: false, rateValue: null, prevRateValue: null },
    { id: 'retailMarginT1', text: 'RETAIL MARGIN TIER 1', selected: false, rateValue: null, prevRateValue: null },
    { id: 'retailMarginT2', text: 'RETAIL MARGIN TIER 2', selected: false, rateValue: null, prevRateValue: null },
    { id: 'retailMarginT3', text: 'RETAIL MARGIN TIER 3', selected: false, rateValue: null, prevRateValue: null },
    { id: 'prepayPc', text: 'PREPAY PERCENTAGE', selected: false, rateValue: null, prevRateValue: null }
  ];

  constructor(
    public matDialog: MatDialog,
    private loaderService: LoaderService,
    private cppSraCostSheetService: CppSraCostSheetService,
    private commonService: CommonService,
    private router: Router,
    private toastrService: ToastrService,
    private broadcastService: BroadcastService,
    private configService: ConfigService
  ) {
    this.subscriptionArray.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
    this.subscriptionForSraReload = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationStart) {
        if (!((e.url === '/cpp/sra-cost-sheet-retail') || (e.url === '/cpp/sra-cost-sheet-price-simulation'))) {
          this.cppSraCostSheetService.setOldFilters(null);
        }
      }
    });
  }

  ngOnInit(): void {
    //redirect to lnding page if no access
    if (!this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST)
      || this.cppSraCostSheetService.isSraCostSheetAccess != 'Y'
    ) {
      this.router.navigate(['/cpp/sra-cost-sheet-retail']);
    }

    //get data for grid if filter has value else redirect to landing page
    this.filterList = Object.assign({}, this.cppSraCostSheetService.getOldFilters());
    if (this.filterList != null) {
      this.originalDisplayedColumns = this.filterList.simulationDisplayedColumns;
      this.columnNames = this.originalDisplayedColumns.map(x => x.columnfield);
      this.tilesList = this.tilesList.filter(tile => this.columnNames.includes(tile.id));
      this.getToggleColumnData();
    }
    else {
      this.router.navigate(['/cpp/sra-cost-sheet-retail']);
    }
  }

  closePage() {
    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Save', dialogType: 'confirm' }
      });
      this.subscriptionArray.push(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
          this.router.navigate(['/cpp/sra-cost-sheet-retail']);;
        }
      }));
    }
    else { this.router.navigate(['/cpp/sra-cost-sheet-retail']); }
  }

  get selectedItemCount(): number {
    return this.tilesList.filter(x => x.selected == true).length;
  }
  checkSimulationDisableChange() {
    this.tilesList.filter(y => y.selected == false || !y.rateValue).map(x => {
      x.rateValue = null;
      return x;
    });
    this.isResetAllDisable = this.tilesList.filter(x => x.selected == true && x.rateValue).length > 0 ? false : true;
    for (let i = 0; i < this.tilesList.length; i++) {
      if (this.tilesList[i].selected == true && this.tilesList[i].rateValue) {
        this.isSimulationDisable = false;
        this.isRunSimulationDisable = false;
        this.isAcceptRateDisable = false;
        this.hasChangeAdded = true;
        break;
      }
      else {
        this.isSimulationDisable = true;
        this.isRunSimulationDisable = true;
        this.isAcceptRateDisable = true;
      }
    }

    if (this.selectedItemCount == 0) {
      this.resetTiles();
    }
  }
  tileSelection(isSelectAll: boolean) {
    if (isSelectAll) {
      this.tilesList.filter(y => y.selected == false).map(x => {
        x.selected = isSelectAll;
        x.rateValue = null;
        return x;
      });
    }
    else {
      this.resetTiles();
    }
  }

  resetTiles() {
    this.tilesList.map(x => {
      x.selected = false;
      x.rateValue = null;
      return x;
    });
    this.isSimulationDisable = true;
    this.hasChangeAdded = false;
    this.isResetAllDisable = true;
    this.isRunSimulationDisable = true;
    this.isAcceptRateDisable = true;
  }

  findColumninvolment(columnKey: string) {
    const cols = this.columnInvolvement[columnKey];
    const toBeFalse = this.columnNames.filter(val => !cols.includes(val));
    if (toBeFalse.length > 0) {
      toBeFalse.map((x) => this.coloumnToAddHeaderCss[x] = false);
    }
    if (cols.length > 0) {
      this.coloumnToAddHeaderCss[columnKey] = true;
      cols.map((x) => {
        this.coloumnToAddHeaderCss[x] = true;
      });
    }
  }

  getToolTipValue(key: string) {
    switch (key) {
      case 'distributorList':
        return 'Similar to redemption price';
      case 'wholesaleRebatePcguidance':
        return 'Static wholesale rebate by product through crop year';
      case 'sraRebatePCGuidance':
        return 'Static SRA retail rebate by product through \n crop year';
      case 'distributionCost':
        return 'WU distribution cost, transparent with \n vended cost pricing';
      case 'wuDeliveredCost':
        return 'Vended cost pricing is distributor list pricing less wholesale guidance rates, plus WU distribution and mfg surcharges';
      case 'prepayEligible':
        return 'Determines if current prepay contract by \n account & product';
      case 'contractPrepayPc':
        return 'Displays contracted prepay % by account';
      case 'lowNetwPrepay':
        return 'Discounts contracted prepay amount from \n low net price';
      case 'currentAprpc':
        return 'Current month\'s APR rate';
      case 'decAprpc':
        return 'December APR rate for current crop year';
      case 'juneAprpc':
        return 'June APR rate for current crop year';
    }
  }

  GetGridData() {
    this.isRunSimulationDisable = true;
    this.loaderService.setLoaderStatus(true);
    this.filterList.currentTabIndex = 2;
    this.filterList.retailStockingRebatePC = this.tilesList.some(x => x.id == 'retailStockingRebate') ? this.tilesList.find(x => x.id == 'retailStockingRebate').selected == true && this.tilesList.find(x => x.id == 'retailStockingRebate').rateValue ? this.tilesList.find(x => x.id == 'retailStockingRebate').rateValue : null : null;
    this.filterList.retailUnpublishedRebatePC = this.tilesList.some(x => x.id == 'retailUnpublishedRebates') ? this.tilesList.find(x => x.id == 'retailUnpublishedRebates').selected == true && this.tilesList.find(x => x.id == 'retailUnpublishedRebates').rateValue ? this.tilesList.find(x => x.id == 'retailUnpublishedRebates').rateValue : null : null;
    this.filterList.retailLocalRebatePC = this.tilesList.some(x => x.id == 'retailLocalRebate') ? this.tilesList.find(x => x.id == 'retailLocalRebate').selected == true && this.tilesList.find(x => x.id == 'retailLocalRebate').rateValue ? this.tilesList.find(x => x.id == 'retailLocalRebate').rateValue : null : null;
    this.filterList.retailMarginTier1PC = this.tilesList.some(x => x.id == 'retailMarginT1') ? this.tilesList.find(x => x.id == 'retailMarginT1').selected == true && this.tilesList.find(x => x.id == 'retailMarginT1').rateValue ? this.tilesList.find(x => x.id == 'retailMarginT1').rateValue : null : null;
    this.filterList.retailMarginTier2PC = this.tilesList.some(x => x.id == 'retailMarginT2') ? this.tilesList.find(x => x.id == 'retailMarginT2').selected == true && this.tilesList.find(x => x.id == 'retailMarginT2').rateValue ? this.tilesList.find(x => x.id == 'retailMarginT2').rateValue : null : null;
    this.filterList.retailMarginTier3PC = this.tilesList.some(x => x.id == 'retailMarginT3') ? this.tilesList.find(x => x.id == 'retailMarginT3').selected == true && this.tilesList.find(x => x.id == 'retailMarginT3').rateValue ? this.tilesList.find(x => x.id == 'retailMarginT3').rateValue : null : null;
    this.filterList.prepayPC = this.tilesList.some(x => x.id == 'prepayPc') ? this.tilesList.find(x => x.id == 'prepayPc').selected == true && this.tilesList.find(x => x.id == 'prepayPc').rateValue ? this.tilesList.find(x => x.id == 'prepayPc').rateValue : null : null;
    this.filterList.retailBaseRebates = this.tilesList.some(x => x.id == 'retailBaseRebates') ? this.tilesList.find(x => x.id == 'retailBaseRebates').selected == true && this.tilesList.find(x => x.id == 'retailBaseRebates').rateValue ? this.tilesList.find(x => x.id == 'retailBaseRebates').rateValue : null : null;
    // set columns Exclusion flags for calculations
    this.filterList.manufacturerSurcharge = this.columnSelection.manufacturerSurcharge;
    this.filterList.distributionCost = this.columnSelection.distributionCost;
    this.filterList.retailStockingRebate = this.columnSelection.retailStockingRebate;
    this.filterList.retailUnpublishedRebates = this.columnSelection.retailUnpublishedRebates;
    this.filterList.retailLocalRebate = this.columnSelection.retailLocalRebate;

    this.simulationExportFilters = Object.assign({}, this.filterList);
    //keep old values
    this.tilesList.map(x => {
      x.rateValue = x.rateValue ? x.rateValue : null;
      x.prevRateValue = x.rateValue;
      return x;
    });

    this.subscription.add(this.cppSraCostSheetService.getSRAGridSimulationData(this.filterList).subscribe(result => {
      if (result && result.costSheet) {
        this.costSheetDataSimulationList = result.costSheet;
        this.costSheetDataSimulationSource = new MatTableDataSource(this.costSheetDataSimulationList);
        this.costSheetDataSimulationSource.paginator = this.costSheetSimulationPaginator;
        this.rowSpans = this.rowSpanComputer.compute(this.costSheetDataSimulationList, this.columnName, this.columnNames);
      }
      this.loaderService.setLoaderStatus(false);
    }, () => { this.loaderService.setLoaderStatus(false); }));
  }

  exportExcel() {
    this.loaderService.setLoaderStatus(true);
    this.simulationExportFilters.currentTabIndex = 2;
    this.simulationExportFilters.isExport = true;
    this.simulationExportFilters.displayedColumns = this.originalDisplayedColumns.map(x => x.headertxt);
    this.subscription.add(this.cppSraCostSheetService.getSRAGridTabDataExport(this.simulationExportFilters).subscribe(result => {
      this.cppSraCostSheetService.base64toFile(result.base64, result.mimeType, result.fileName);
      this.simulationExportFilters.isExport = false;
      this.loaderService.setLoaderStatus(false);
    }, () => { this.loaderService.setLoaderStatus(false); }));
  }

  saveTempRates(isReset, isUserPreferenceSave) {
    if (this.costSheetDataSimulationList && this.costSheetDataSimulationList.length > 0) {
      const customerItem = [];

      this.costSheetDataSimulationList.forEach(x => {
        customerItem.push({ customerNumber: x.customerNumber, itemId: x.itemID, itemNumber: x.winfieldProduct });
      });

      var postData = {
        isReset: isReset,
        isSelectedRetailStockingRebatePC: this.tilesList.some(x => x.id == 'retailStockingRebate') ? this.tilesList.find(x => x.id == 'retailStockingRebate').selected : false,
        retailStockingRebatePC: this.tilesList.some(x => x.id == 'retailStockingRebate') ? this.tilesList.find(x => x.id == 'retailStockingRebate').selected == true ? this.tilesList.find(x => x.id == 'retailStockingRebate').rateValue : null : null,
        isSelectedRetailUnpublishedRebatePC: this.tilesList.some(x => x.id == 'retailUnpublishedRebates') ? this.tilesList.find(x => x.id == 'retailUnpublishedRebates').selected : false,
        retailUnpublishedRebatePC: this.tilesList.some(x => x.id == 'retailUnpublishedRebates') ? this.tilesList.find(x => x.id == 'retailUnpublishedRebates').selected == true ? this.tilesList.find(x => x.id == 'retailUnpublishedRebates').rateValue : null : null,
        isSelectedRetailLocalRebatePC: this.tilesList.some(x => x.id == 'retailLocalRebate') ? this.tilesList.find(x => x.id == 'retailLocalRebate').selected : false,
        retailLocalRebatePC: this.tilesList.some(x => x.id == 'retailLocalRebate') ? this.tilesList.find(x => x.id == 'retailLocalRebate').selected == true ? this.tilesList.find(x => x.id == 'retailLocalRebate').rateValue : null : null,
        isSelectedRetailMarginTier1PC: this.tilesList.some(x => x.id == 'retailMarginT1') ? this.tilesList.find(x => x.id == 'retailMarginT1').selected : false,
        retailMarginTier1PC: this.tilesList.some(x => x.id == 'retailMarginT1') ? this.tilesList.find(x => x.id == 'retailMarginT1').selected == true ? this.tilesList.find(x => x.id == 'retailMarginT1').rateValue : null : null,
        isSelectedRetailMarginTier2PC: this.tilesList.some(x => x.id == 'retailMarginT2') ? this.tilesList.find(x => x.id == 'retailMarginT2').selected : false,
        retailMarginTier2PC: this.tilesList.some(x => x.id == 'retailMarginT2') ? this.tilesList.find(x => x.id == 'retailMarginT2').selected == true ? this.tilesList.find(x => x.id == 'retailMarginT2').rateValue : null : null,
        isSelectedRetailMarginTier3PC: this.tilesList.some(x => x.id == 'retailMarginT3') ? this.tilesList.find(x => x.id == 'retailMarginT3').selected : false,
        retailMarginTier3PC: this.tilesList.some(x => x.id == 'retailMarginT3') ? this.tilesList.find(x => x.id == 'retailMarginT3').selected == true ? this.tilesList.find(x => x.id == 'retailMarginT3').rateValue : null : null,
        isSelectedPrepayPC: this.tilesList.some(x => x.id == 'prepayPc') ? this.tilesList.find(x => x.id == 'prepayPc').selected : false,
        prepayPC: this.tilesList.some(x => x.id == 'prepayPc') ? this.tilesList.find(x => x.id == 'prepayPc').selected == true ? this.tilesList.find(x => x.id == 'prepayPc').rateValue : null : null,
        isSelectedRetailBaseRebates: this.tilesList.some(x => x.id == 'retailBaseRebates') ? this.tilesList.find(x => x.id == 'retailBaseRebates').selected : false,
        retailBaseRebates: this.tilesList.some(x => x.id == 'retailBaseRebates') ? this.tilesList.find(x => x.id == 'retailBaseRebates').selected == true ? this.tilesList.find(x => x.id == 'retailBaseRebates').rateValue : null : null,
        customerNumberItemIdList: customerItem
      };

      //reset tiles value
      if (isReset) {
        this.resetTiles();
      } else {
        this.isAcceptRateDisable = true;
      }

      this.loaderService.setLoaderStatus(true);
      this.subscription.add(this.cppSraCostSheetService.saveTempRates(postData).subscribe(result => {
        if (result) {
          this.hasChangeAdded = false;
          if (!isReset && !isUserPreferenceSave) {
            this.toastrService.success('New rates will be updated to actual cost though overnight refresh.');
          }
          this.GetGridData();
        }
        this.loaderService.setLoaderStatus(false);
      }, () => {
        this.loaderService.setLoaderStatus(false);
        this.isAcceptRateDisable = false;
      }));
    }
  }

  getToggleColumnData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppSraCostSheetService.getToggleSettings("Simulation").subscribe(result => {
      if (result) {
        result.ToggleColumns.forEach(obj => {
          let column = obj.ColumnName;
          switch (column) {
            case 'manufacturerSurcharge':
              this.columnSelection.manufacturerSurcharge = obj.IsChecked;
              break;
            case 'distributionCost':
              this.columnSelection.distributionCost = obj.IsChecked;
              break;
            case 'retailStockingRebate':
              this.columnSelection.retailStockingRebate = obj.IsChecked;
              break;
            case 'retailUnpublishedRebates':
              this.columnSelection.retailUnpublishedRebates = obj.IsChecked;
              break;
            case 'retailLocalRebate':
              this.columnSelection.retailLocalRebate = obj.IsChecked;
              break;
          }
        });
      }
      this.GetGridData();
    }, () => { this.loaderService.setLoaderStatus(false); }));
  }

  saveToggleColumnSettings() {
    this.loaderService.setLoaderStatus(true);
    const toggleList = [
      { columnName: 'manufacturerSurcharge', isChecked: this.columnSelection.manufacturerSurcharge },
      { columnName: 'distributionCost', isChecked: this.columnSelection.distributionCost },
      { columnName: 'retailStockingRebate', isChecked: this.columnSelection.retailStockingRebate },
      { columnName: 'retailUnpublishedRebates', isChecked: this.columnSelection.retailUnpublishedRebates },
      { columnName: 'retailLocalRebate', isChecked: this.columnSelection.retailLocalRebate }
    ];
    const filter = {
      toggleColumns: toggleList,
      tabName: "Simulation"
    };
    this.subscription.add(this.cppSraCostSheetService.saveToggleSettings(filter).subscribe(result => {
      if (result) {
        this.toastrService.success('Toggle Preferences Settings saved successfully.');
        this.saveTempRates(false, true);
      }
      else {
        this.toastrService.success('Toggle Preferences Settings not saved in the system.');
      }
      this.loaderService.setLoaderStatus(false);
    }, () => { this.loaderService.setLoaderStatus(false); }));
  }

  columnCheckboxSelection(key: string, event: any) {
    this.columnSelection[key] = event.checked;
    this.isSimulationDisable = false;
    this.isRunSimulationDisable = false;
  }

  keyPressNumeric(event: any) {
    let input = event.target.value + String.fromCharCode(event.charCode);
    if (!this.NumericPattern.test(input)) {
      event.preventDefault();
    }
  }
  amountValue(val): string {
    return '$' + `${!val ? '0.00' : val.toFixed(2)}`;
  }

  percentValue(val): string {
    return `${!val ? '0.00' : val.toFixed(2)}` + '%';
  }

  roundValue(val): string {
    return `${!val ? '0.00' : val.toFixed(2)}`;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscriptionArray.forEach(subscription => subscription.unsubscribe());
    if (this.subscriptionForSraReload) {
      this.subscriptionForSraReload.unsubscribe();
    }
  }
}
